<template>
  <div class="video-notplay-helper">
    <div @mouseover="hover = true" v-if="!hover">
      <icon class="video-notplay-helper-icon" type="ask_normal"></icon>
    </div>
    <div
      v-else
      class="video-notplay-helper-hint"
      @mouseleave="hover = false"
    >
      <div class="video-notplay-helper-text">
        <span style="margin-left: 16px">若视频黑屏，请关闭浏览器硬件加速</span>
        <span
          class="video-notplay-helper-link"
          @click="openLinkInNewTab"
        >
          操作说明
          <icon type="more"></icon>
        </span>
      </div>
      <icon class="video-notplay-helper-icon" type="ask_hover" @click="openLinkInNewTab"></icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {},


  data() {
    return {
      hover: false,
      visible: true,
      docLink: 'https://www.kdocs.cn/l/clyfBOzoy8pv'
    };
  },
  methods: {
    openLinkInNewTab() {
      window.open(this.docLink, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.video-notplay-helper {
  &-hint {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &-text {
    background: rgba($color: #000000, $alpha: 0.4);
    display: flex;
    align-items: center;
    border-radius: 14px;
    width: 292px;
    height: 28px;
    font-size: 12px;
    color: #ffffff;
    margin-right: 6px;
  }
  &-link {
    font-size: 12px;
    color: #2c71fa;
    margin-left: 8px;
  }
  &-icon {
    font-size: 28px;
  }
}
</style>
